import { render, staticRenderFns } from "./SubsidyDetail.vue?vue&type=template&id=77a43341&scoped=true"
import script from "./SubsidyDetail.vue?vue&type=script&lang=js"
export * from "./SubsidyDetail.vue?vue&type=script&lang=js"
import style0 from "./SubsidyDetail.vue?vue&type=style&index=0&id=77a43341&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a43341",
  null
  
)

export default component.exports